<template>
  <div>
    <el-backtop :right="50" :bottom="100" />
    <div class="layout_up" :style="{ background: bgColor || backgroundColorChange }">
      <div class="navCon flex_between cursor w_1280">
        <div class="navbar_logo cursor" @click="goPage('/')">
          <img src="@/assets/images/logo.png" alt="">
        </div>
        <div class="flex color_fff">
          <div class="flex_center flex_column ml30 cursor" @click="goUrlToken(systemLink[2].value)">
            <div>产业大脑</div>
          </div>
          <div class="flex_center flex_column ml30 cursor" @click="goUrlToken(systemLink[0].value)">
            <div>协同系统</div>
          </div>
          <div class="flex_center flex_column ml30 cursor" @click="goUrl(systemLink[3].value)">
            <div>商家入驻</div>
          </div>

          <!-- <div class="top_box flex_center color_fff" v-if="!isLogin">
            登录/注册
          </div>
          <div class="user_icon color_fff" v-else>
            <el-icon>
              <User />
            </el-icon>
          </div> -->
        </div>
      </div>


      <!-- <div class="about_us_box flex_center cursor" @click="goPage('/aboutUs')">
      关于我们
    </div> -->
    </div>
    <div class="carousel">
      <div class="w_1280 flex_end">
        <el-skeleton class="login_main" style="height: 400px" :loading="barLoading" animated>
          <div class="login_main" v-if="!isLogin">
            <div class="login_box">
              <div class="login_title flex">
                <div class="title_left flex_column">
                  <span>欢迎登录</span>
                </div>
              </div>
              <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                <el-tab-pane label="手机登录" name="phone"></el-tab-pane>
                <el-tab-pane label="密码登录" name="password"></el-tab-pane>
              </el-tabs>
              <div class="login_input-label">账号</div>
              <div class="login_input flex">
                <el-icon color="#2567F1" style="font-size: 19px">
                  <Avatar />
                </el-icon>
                <input :placeholder="activeName === 'password' ? '账号' : '手机号'" v-model.trim="formState.username"
                  type="text" @input="updateInput('username', $event)" />
              </div>
              <div class="login_input-label" v-show="activeName === 'password'">密码</div>
              <div class="login_input flex" v-show="activeName === 'password'">
                <el-icon color="#2567F1" style="font-size: 19px">
                  <Lock />
                </el-icon>
                <input placeholder="密码" v-model.trim="formState.password"
                  :type="isPasswordVisible ? 'text' : 'password'" @input="updateInput('password', $event)" />
                <el-icon class="cursor" style="font-size: 18px;" @click="viewPass(false)" v-if="isPasswordVisible">
                  <Hide />
                </el-icon>
                <el-icon class="cursor" style="font-size: 18px;" @click="viewPass(true)" v-else>
                  <View />
                </el-icon>
              </div>
              <div class="login_input-label" v-show="activeName === 'phone'">验证码</div>
              <div v-show="activeName === 'phone'" style="display: flex">
                <div class="login_input flex" style="width: 45%">
                  <el-icon color="#2567F1" style="font-size: 19px">
                    <Lock />
                  </el-icon>
                  <input placeholder="验证码" v-model.trim="formState.code" @input="updateInput('password', $event)" />
                </div>
                <div class="login_input flex hqyzm" @click="codeDis ? '' : getCode()">{{ codeText }}</div>
              </div>
              <div class="login_btn" @click="loginSuccess()">
                <button>登 录</button>
              </div>
              <!-- <div class="flex_between" v-show="activeName === 'password'">
                <div class="cursor">
                  <div class="color_000" @click="goPage('/resetPasswordPage')">
                    <div>忘记密码</div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <div class="login_main" v-else>
            <div class="personal_info color_fff">
              <div class="exit_btn flex_end fz16 cursor" @click="exitLogin">退出 <img src="@/assets/images/exitIcon.png"
                  alt="" />
              </div>
              <div class="flex">
                <div class="profile_picture">
                  <img src="@/assets/images/profileImg.png" alt="" />
                </div>
                <div class="personal_right">
                  <div v-if="authInfo.authStatus != 1">{{ userName }}</div>
                  <div v-if="authInfo.authStatus == 1">{{ authInfo.name }}</div>
                  <div class="company_name text_overflow" v-if="authInfo.authStatus != 1">
                    {{ authInfo.companyName }}
                  </div>
                </div>
              </div>

            </div>
            <div class="personal_main flex_center flex_column" v-if="authInfo.userType == '01'">
              <div class="improve_info_warn" v-if="authInfo.authStatus == 2">
                驳回原因：{{ authInfo.authReason }}
              </div>
              <div class="improve_info_warn" v-if="authInfo.authStatus == null || authInfo.authStatus == 2">
                为给您带来更优质的服务体验
                请您尽快完善个人信息
              </div>
              <div class="improve_info_btn flex_center cursor"
                v-if="authInfo.authStatus == null || authInfo.authStatus == 2" @click="editPersonalInfo">
                完善信息
              </div>

              <div class="examine_box flex_center flex_column" v-if="authInfo.authStatus == 0">
                <img src="@/assets/images/examineIcon.png" alt="" />
                <span>等待客服审核... ...</span>
                <span>{{systemLink[8].name}}：{{systemLink[8].value}}</span>
              </div>

              <div class="order_invoice_btn flex_center mb12 cursor" v-if="authInfo.authStatus == 1"
                @click="goUrlToken(pathList.tourist.financePath)"><img src="@/assets/images/orderIcon.png" alt="" /> 订单
              </div>
              <div class="order_invoice_btn flex_center cursor" v-if="authInfo.authStatus == 1"
                @click="goUrlToken(pathList.tourist.financePath)"><img src="@/assets/images/invoiceIcon.png" alt="" />
                发票
              </div>
              <div class="improve_info_btn flex_center cursor" v-if="authInfo.authStatus == 1"
                @click="goUrlToken(systemLink[0].value)">
                进入协同系统</div>
            </div>

            <div class="personal_main flex_center flex_column" v-else>
              <div class="order_invoice_btn flex_center mb12 cursor" @click="goUrlToken(pathList.system.financePath)">
                <img src="@/assets/images/orderIcon.png" alt="" /> 订单
              </div>
              <div class="order_invoice_btn flex_center cursor" @click="goUrlToken(pathList.system.orderPath)"><img
                  src="@/assets/images/invoiceIcon.png" alt="" /> 发票</div>
              <div class="improve_info_btn flex_center cursor" @click="goUrlToken(systemLink[0].value)">进入协同系统</div>
            </div>
          </div>
        </el-skeleton>
      </div>
    </div>

    <div class="nav_bar_two_list">
      <div class="navbar_box_list w_1280 flex_between cursor">
        <div class="navbar_box flex_center flex_column"
          :class="navigationIndex == item.index ? 'navbar_box_select' : ''" v-for="item in navbarList" :key="item.index"
          @click="switchNavigation(item)">
          <div>{{ item.name }}</div>
          <div :class="navigationIndex == item.index ? 'navbar_line_select' : 'navbar_line'"></div>
        </div>
      </div>

    </div>

    <div class="personal_info_mask" v-if="personalBox">

    </div>
    <div class="personal_info_box" v-if="personalBox">
      <div class="login_title flex_between">
        <div class="title_left">
          <span>请完善信息</span>
        </div>
        <div class="cursor" @click="personalBox = false">
          <el-icon>
            <CloseBold />
          </el-icon>
        </div>
      </div>
      <el-form ref="ruleFormRef" label-position="left" :model="ruleForm" status-icon :rules="rules" label-width="100px"
        class="demo-ruleForm">
        <el-form-item label="姓  名" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="ruleForm.companyName" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="职  务" prop="position">
          <el-input v-model.number="ruleForm.position" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model.number="ruleForm.phone" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model.number="ruleForm.password" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="联系地址" prop="address">
          <el-input v-model.number="ruleForm.address" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div>
        <div class="personal_info_btn flex_center color_fff cursor" type="primary" @click="submitForm('ruleFormRef')">提交
        </div>
      </div>
    </div>

    <div class="customer_service_mask" v-if="iscustomer" @click="iscustomer = false">

    </div>

    <div class="customer_service_box flex_center flex_column cursor" v-if="iscustomer">
      <img src="@/assets/images/customerServiceImg.png" alt="" />
      <div class="customer_phone flex">130-0656-7910 <el-icon class="ml10" @click="copyText('130-0656-7910')">
          <CopyDocument />
        </el-icon></div>
    </div>

  </div>
</template>

<script>
import { login, sendMsg, userInfo, systemInfo, autherInfo, insertInfo, updateInfo, userPath } from "@/utils/api";
export default {
  name: 'navbar',
  props: {
    navigationIndex: String,
    bgColor: String
  },
  components: {
  },
  data() {
    return {
      barLoading: false,
      isLogin: true,
      navbarList: [
        {
          name: '首页',
          index: 0,
          url: '/'
        },
        {
          name: '每日焦易',
          index: 1,
          url: '/dailyJiaoYi'
        },
        {
          name: '焦好运',
          index: 2,
          url: 'https://www.jhy56.cn/'
          // jiaoJiuyun
        },
        {
          name: '焦真质检',
          index: 3,
          url: '/'
          // qualityTesting
        },
        {
          name: '咨询指数',
          index: 4,
          url: '/'
        },
        {
          name: '焦易小智',
          index: 5,
          url: '/jiaoYiAi'
        },
        {
          name: '关于我们',
          index: 6,
          url: '/'
        },
      ],
      userName: localStorage.getItem('userName'),
      backgroundColorChange: null,
      codeDis: false,
      codeText: '获取验证码',
      time: 60,
      activeName: 'phone',
      formState: {
        username: '',
        password: '',
      },
      isPasswordVisible: false,

      ruleForm: {
        userId: "",
        name: '',
        companyName: '',
        position: '',
        phone: '',
        password: '',
        address: '',
      },
      rules: {
        // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        companyName: [{ required: true, message: '请输入公司名', trigger: 'change' }],
        position: [{ required: true, message: '请输入职务', trigger: 'change' }],
        phone: [{ required: true, message: '请输入联系方式', trigger: 'change' }],
        password: [{ required: true, message: '请输入密码', trigger: 'change' }],
        address: [{ required: true, message: '请输入联系地址', trigger: 'change' }],
      },
      personalBox: false,
      authInfo: {},
      pathList: {},

      iscustomer: false,
    };
  },
  mounted() {
    if (this.$route.query.token) {
      let token = this.$route.query.token;
      localStorage.token = token;
    }
    this.getUserInfo();
    this.getSystemInfo();
    this.getAutherInfo();
    this.getUserPath();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    copyText(text) {
      var textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      textarea.value = text
      textarea.select();
      document.execCommand("copy")
      document.body.removeChild(textarea)
      this.$message.success("复制成功")
    },
    async getUserPath() {
      let res = await userPath();
      if (res.code == 200) {
        this.pathList = res.data;
      }
    },
    // 退出登录
    exitLogin() {
      localStorage.clear();
      this.isLogin = false;
    },
    // 打开完善信息
    editPersonalInfo() {
      this.personalBox = true;
      this.ruleForm = {
        userId: "",
        name: '',
        companyName: '',
        position: '',
        phone: '',
        password: '',
        address: '',
      };
      if (this.authInfo.authStatus == 2) {
        this.ruleForm = {
          userId: this.authInfo.userId,
          name: this.authInfo.name,
          companyName: this.authInfo.companyName,
          position: this.authInfo.position,
          phone: this.authInfo.phone,
          password: this.authInfo.password,
          address: this.authInfo.address,
        };
      }
    },
    // 提交完善信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.authInfo.authStatus == 2) {
            updateInfo(this.ruleForm).then((res) => {
              if (res.code == 200) {
                this.$message.success('提交成功');
                this.getAutherInfo();
                this.personalBox = false;
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            insertInfo(this.ruleForm).then((res) => {
              if (res.code == 200) {
                this.$message.success('提交成功');
                this.getAutherInfo();
                this.personalBox = false;
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 获取系统信息
    async getSystemInfo() {
      let res = await systemInfo();
      if (res.code == 200) {
        this.systemLink = res.data.link;
      }
    },
    handleCommand(command) {
      console.log(`click on item ${command}`)
    },
    handleScroll() {
      const scrollTop = window.scrollY;
      if (scrollTop === 0) {
        this.backgroundColorChange = null;
      } else {
        this.backgroundColorChange = '#0E1C42';
      }
    },
    switchNavigation(item) {
      // this.navigationIndex = item.index;
      if (item.index == 2) {
        window.open(item.url, '_blank');
      } else {
        window.open(
          this.$router.resolve({
            path: item.url
          }).href,
          '_blank' // 新窗口
        );
      }
      // this.$router.push({
      //   path: item.url
      // });

    },

    goUrl(url) {
      window.open(url, '_blank');
    },
    goUrlToken(url) {
      window.open(url + '?token=' + localStorage.token, '_blank');
    },

    // 获取验证码
    getCode() {
      if (this.formState.username == '' || this.formState.username == null) {
        this.$message.error('手机号不能为空');
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.formState.username)) {
        this.$message.error("手机号码有误，请重填");
        return;
      }
      sendMsg({ phone: this.formState.username }).then((res) => {
        if (res.code == 200) {
          let timer = setInterval(() => {
            this.codeDis = true;
            this.codeText = this.time + 's后重新获取';
            if (this.time > 0) {
              this.time--;
            } else {
              this.codeDis = false;
              this.codeText = '获取验证码';
              this.time = 60;
              clearInterval(timer);
            }
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 检测输入框格式
    updateInput(field, event) {
      this.formState[field] = event.target.value.replace(/\s+/g, '');
    },
    // 查看密码
    viewPass(isPassword) {
      // console.log(isPassword);
      this.isPasswordVisible = isPassword;
    },
    // 登录
    loginSuccess() {
      if (this.activeName === 'password') {
        if (this.formState.username == '' || this.formState.username == null) {
          this.$message.error('账号不能为空');
          return;
        }
        if (this.formState.password == '' || this.formState.password == null) {
          this.$message.error('请输入密码');
          return;
        }
      } else {
        if (this.formState.username == '' || this.formState.username == null) {
          this.$message.error('手机号不能为空');
          return;
        }
        if (!/^1[3456789]\d{9}$/.test(this.formState.username)) {
          this.$message.error("手机号码有误，请重填");
          return;
        }
        if (this.formState.code == '' || this.formState.code == null) {
          this.$message.error('请输入验证码');
          return;
        }
      }
      login({ phonenumber: this.formState.username, code: this.formState.password }).then((res) => {
        if (res.code == 200) {
          localStorage.token = res.token;
          this.$message.success('登录成功');
          this.getUserInfo();
          this.getAutherInfo();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取用户信息
    getUserInfo() {
      this.barLoading = true;
      userInfo().then((res) => {
        if (res.code == 200) {
          localStorage.userName = res.user.userName;
          localStorage.userId = res.user.userId;
          localStorage.authFlag = res.authFlag;
          localStorage.userType = res.user.userType;
          this.userName = localStorage.getItem('userName');
          this.isLogin = true;
          // 触发自定义事件
          this.$emit('customEvent', this.isLogin);
        } else {
          this.isLogin = false;
          // 触发自定义事件
          this.$emit('customEvent', this.isLogin);
        }
      }).finally(() => {
        this.barLoading = false;
      });

    },

    // 获取实名信息
    async getAutherInfo() {
      let res = await autherInfo();
      if (res.code == 200) {
        this.authInfo = res.data;
      }
    },
    goPage(path) {
      this.$router.push({
        path: path
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.layout_up {
  position: fixed;
  z-index: 9;
  top: 0;
  width: 100%;
  height: 120px;
  background: linear-gradient(180deg, #0E1C42 0%, rgba(14, 27, 65, 0) 100%);
}

.user_icon {
  margin-left: 20px;
  font-size: 20px;
  line-height: 20px;
}

.top_box {
  width: 125px;
  height: 43px;
  background: #238AFE;
  border-radius: 6px;
  margin-left: 20px;
  font-size: 16px;
  color: #FFFFFF;
}

.navCon {
  height: 100%;
}

.navbar_logo {
  width: 375px;
  margin-right: 60px;

  img {
    width: 367px;
    height: auto;
  }
}

.navbar_box {
  width: 135px;
  height: 100%;
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
}

.navbar_box_select {
  background: #238AFE;
}

.navbar_line {
  height: 3px;
  width: 100%;
  border-radius: 2px;
  margin-top: 5px;
}

.navbar_line_select {
  height: 3px;
  width: 33px;
  background-color: #fff;
  border-radius: 2px;
  margin-top: 5px;
}

.el-dropdown-link {
  cursor: pointer;
  outline: none;
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

/* 覆盖下拉框的背景颜色 */
.el-dropdown-menu {
  background-color: #284187;
  border: none;
}

// 嵌套修改下拉菜单项样式
:deep .el-dropdown-menu__item {
  color: #CECECE;
  font-size: 16px;

  &:hover {
    background-color: #238AFE;
    color: #ffffff;
  }
}

.about_us_box {
  position: fixed;
  width: 10px;
  height: 130px;
  background-color: #00AC64;
  border-radius: 20px;
  bottom: 150px;
  right: 20px;
  color: #fff;
  font-size: 18px;
  padding: 0 15px;
}

.carousel {
  // padding-top: 80px;
  height: 621px;
  background: url("@/assets/images/banner.png") no-repeat center;
  background-size: cover;
}

.carousel_top_title {
  font-weight: bold;
  font-size: 72px;
  color: #ffffff;
  padding-top: 140px;
}

.carousel_text {
  font-weight: 500;
  font-size: 29px;
  color: #ffffff;
  margin-top: 34px;
}

.no-select {
  user-select: none;
  /* 禁止文本选择 */
  pointer-events: none;
  /* 禁止鼠标事件（无法点击、拖动等） */
  -webkit-user-drag: none;
  /* 禁止 WebKit 浏览器拖动 */
  cursor: default;
  /* 更改鼠标样式，避免误导 */
}

.login_main {
  width: 340px;
  // height: 404px;
  background: #FFFFFF;
  box-shadow: 0 0 8px 2px rgba(21, 62, 155, .6);
  border-radius: 8px;
  margin-top: 150px;
}

.login_box {
  padding: 31px 31px 28px 31px;
}

.login_title {
  font-size: 24px;
  color: #333333;
  font-family: SOURCEHANSANSCN-BOLD;
  display: flex;
  align-items: baseline;
  font-weight: bold;
  position: relative;
  margin-left: 12px;
  // margin-bottom: 26px;

  &::before {
    position: absolute;
    left: -8px;
    bottom: 9px;
    width: 4px;
    height: 16px;
    background: linear-gradient(0deg, #015EEA 0%, #00C0FA 100%);
    content: '';
  }
}

.login_line {
  width: 50px;
  height: 4px;
  background: #11672e;
  border-radius: 2px;
  margin-top: 3px;
}

.title_right {
  font-size: 15px;
  font-weight: 400;
  color: #aeaeae;
  margin-left: 5px;
  margin-bottom: 10px;
}

.login_input-label {
  // margin-top: 18px;
  font-size: 16px;
  margin-bottom: 7px;
}

.login_input {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  height: 35px;
  padding: 0 10px;
  font-size: 16px;
  margin-bottom: 16px;
}

.hqyzm {
  font-size: 15px;
  flex: 1;
  border: 1px solid #2567F1;
  margin-left: 3%;
  color: #2567F1;
  justify-content: center;
  cursor: pointer;
}

.login_input input {
  border: none;
  color: #606266;
  height: 100%;
  font-size: 15px;
  margin: 0;
  padding: 0;
  padding-left: 10px;
  width: 100%;
  margin-right: 20px;
}

.login_btn button {
  width: 100%;
  height: 40px;
  color: #fff;
  background-color: #2567F1;
  border: none;
  // border-radius: 4px;
  margin-top: 20px;
  font-size: 16px;
  font-family: SOURCEHANSANSCN-REGULAR;
}

.title-content {
  color: #626262;
  font-size: 20px;
  font-family: SOURCEHANSANSCN-BOLD;
  line-height: 22px;
  margin-top: 15px;
  margin-bottom: 10px;
}

.title_left {
  display: flex;
  justify-content: start;
}

:deep .login_input {
  height: 40px;
  border: 1px solid #DADADA;
  border-radius: 4px;
}

.color_000 {
  color: #2567F1;
}

::v-deep .el-tabs__item {
  font-size: 16px;
  // line-height: 50px;
  height: 50px;
}

::v-deep .el-tabs {
  width: 100%;
  margin: auto;
}

.nav_bar_two_list {
  position: sticky;
  top: 220px;
  width: 100%;
  height: 113px;
  background: #102F87;
  margin-top: -35px;
  z-index: 1;
}

.navbar_box_list {
  height: 100%;
}

.personal_info_mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(51, 51, 51, 0.8);
  z-index: 19;
}

.personal_info_box {
  position: fixed;
  z-index: 20;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 340px;
  background: #FFFFFF;
  box-shadow: 9px 8px 14px 2px rgba(21, 62, 155, 0.13);
  border-radius: 8px;
  padding: 30px 32px 19px 32px;
}

.demo-ruleForm {
  margin-top: 30px;
}

:deep .el-form-item__label {
  font-size: 16px;
}

.personal_info_btn {
  width: 100%;
  height: 40px;
  background: linear-gradient(252deg, #2567F1 0%, #238AFE 99%);
  margin-top: 27px;
}

.personal_info {
  // width: 100%;
  height: 170px;
  background: #FFFFFF;
  border-radius: 8px;
  background: linear-gradient(-30deg, #015EEA 34%, #238AFE 100%);
  padding: 33px 30px 0 33px;
}

.exit_btn {
  margin-bottom: 15px;
}

.exit_btn img {
  width: 14px;
  height: 15px;
  object-fit: cover;
  margin-left: 5px;
  font-family: AlibabaPuHuiTi-M;
}

.profile_picture {
  margin-right: 12px;
}

.profile_picture img {
  width: 72px;
  height: 71px;
}

.personal_right {
  font-family: AlibabaPuHuiTi-B;
  font-weight: bold;
  font-size: 26px;
  color: #FFFFFF;
}

.company_name {
  width: 180px;
  font-family: AlibabaPuHuiTi-M;
  font-size: 16px;
  font-weight: 500;
  margin-top: 10px;
}

.personal_main {
  width: 100%;
  height: 230px;
  background: #FFFFFF;
  border-radius: 8px;
  margin-top: -30px;
  font-family: AlibabaPuHuiTi-R;
}

.improve_info_warn {
  font-weight: 400;
  font-size: 16px;
  color: #CF2121;
  width: 209px;
  text-align: center;
}

.improve_info_btn {
  width: 257px;
  height: 40px;
  background: linear-gradient(252deg, #2567F1 0%, #238AFE 99%);
  font-weight: 400;
  font-size: 16px;
  color: #FEFEFE;
  margin-top: 31px;
}

.examine_box img {
  width: 146px;
  height: 120px;
}

.examine_box span {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}

.order_invoice_btn {
  width: 259px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #2567F1;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}

.order_invoice_btn img {
  width: 11px;
  height: 15px;
  object-fit: cover;
  margin-right: 5px;
}

.customer_service_mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(51, 51, 51, 0.8);
  z-index: 19;
}

.customer_service_box {
  position: fixed;
  z-index: 20;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 340px;
  background: #FFFFFF;
  box-shadow: 9px 8px 14px 2px rgba(21, 62, 155, 0.13);
  border-radius: 8px;
  padding: 30px 32px 19px 32px;
}

.customer_phone {
  margin-top: 20px;
  font-weight: 600;
  font-size: 23px;
}
</style>
